import { render, staticRenderFns } from "./AvatarEditor.vue?vue&type=template&id=53f13b54"
import script from "./AvatarEditor.vue?vue&type=script&lang=js"
export * from "./AvatarEditor.vue?vue&type=script&lang=js"
import style0 from "./AvatarEditor.vue?vue&type=style&index=0&id=53f13b54&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports